import { Link } from "@tanstack/react-router";
import logoSrc2x from "@/assets/logo-rentalmnp.webp";
import logoSrc1x from "@/assets/logo-rentalmnp@1x.webp";

interface LogoProps {
  /** Hauteur du logo en pixels (largeur auto, ratio préservé) */
  size?: number;
  /** Si true, le logo est cliquable et redirige vers / */
  asLink?: boolean;
  /** Charger en priorité (utile pour LCP au-dessus de la ligne de flottaison) */
  priority?: boolean;
  className?: string;
}

// Ratio natif du fichier source = 600 × 162 ≈ 3.7037
const LOGO_ASPECT = 600 / 162;

/**
 * Logo officiel RentaLMNP — WebP avec srcset 1x / 2x.
 * Largeur/hauteur explicites pour éviter le CLS et améliorer le LCP.
 * Les deux versions sont pré-redimensionnées (163×44 et 326×88) pour limiter
 * le poids à ~4 KiB / ~10 KiB selon la densité d'écran.
 */
export function Logo({ size = 36, asLink = true, priority = false, className = "" }: LogoProps) {
  const height = size;
  const width = Math.round(size * LOGO_ASPECT);

  const img = (
    <img
      src={logoSrc1x}
      srcSet={`${logoSrc1x} 1x, ${logoSrc2x} 2x`}
      alt="RentaLMNP — simulateur LMNP gratuit"
      width={width}
      height={height}
      style={{ height: `${height}px`, width: `${width}px` }}
      className={`block select-none ${className}`}
      draggable={false}
      decoding="async"
      fetchPriority={priority ? "high" : "auto"}
    />
  );

  if (!asLink) return img;

  return (
    <Link to="/" aria-label="Retour à l'accueil RentaLMNP" className="inline-block">
      {img}
    </Link>
  );
}
